/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelPnnZoneReply.ts                  *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/pnn-zone-reply";

export class AutogenModelPnnZoneReply<RowType extends ModelRow> extends Endpoint<RowType, RowPnnZoneReplyFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowPnnZoneReply extends ModelRow<RowPnnZoneReplyFields> {
	constructor(values?: Partial<RowPnnZoneReplyFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowPnnZoneReplyFields {
	company_id: string;
	dispatch_zone: string;
	id: string;
	reply_to_user: string;
}

